import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Select from 'react-select';
import _ from 'underscore';
import './adminFuelTracker.css';

import EditFuelRecord from './sub/editFuelRecord';
import {
    deleteFuelRecord,
    getAllFuelRecords,
} from '../../actions/fuel_records_actions';
import {
    getCars,
} from '../../actions/cars_actions';
import {
    getAllTrackerUsersWithProfile,
} from '../../actions/users_actions';

class AdminFuelTracker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            loadedProps: 0,
            loaded: false,
            showEditFuelRecord: false,
            editRecord: null,
            pagination: {
                page: 1,
                totalPages: 1,
                perPage: 10,
            },
            filter: {
                name: '',
                car: '',
            },
        };

        this.changePage = this.changePage.bind(this);
        this.renderPagesCount = this.renderPagesCount.bind(this);
        this.renderList = this.renderList.bind(this);
    }

    componentDidMount() {
        this.props.getCars();
        this.props.getAllFuelRecords();
        this.props.getAllTrackerUsersWithProfile();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.loadedProps < 3)
            this.state.loadedProps++;

        if(this.state.loadedProps === 3) {
            let {pagination} = this.state;
            pagination.totalPages = Math.ceil(nextProps.fuelRecords.length / pagination.perPage);

            this.setState({
                loaded: true,
                pagination,
            }, this.changePage);
        }
    }

    changePage(page = 1) {
        const list = _.sortBy(this.props.fuelRecords, function (record) {
            return record.dateAdd * -1;
        });

        const filtredList = list.filter(item => {
            const profile = this.props.users.find(user => {
                return item.ownerId === user.key;
            });
            const {name, lastName} = profile;
            const fullName = `${name} ${lastName}`;

            const car = this.props.cars.find(car => {
                if(car.key === item.carKey)
                    return true;
            });

            return fullName.toLowerCase().indexOf(this.state.filter.name.toLowerCase())>=0 &&
                car.name.toLowerCase().indexOf(this.state.filter.car.toLowerCase())>=0;
        });

        let {pagination} = this.state;

        pagination.totalPages = Math.ceil(filtredList.length / pagination.perPage);

        if(page > pagination.totalPages)
            page = pagination.totalPages;

        if(page < 1)
            page = 1;

        pagination.page = page;

        const start = (pagination.page - 1) * (pagination.perPage);
        const end = start + pagination.perPage;

        const fuelRecords = filtredList.slice(start, end);

        this.setState({
            pagination,
            fuelRecords,
        });
    }

    renderPagesCount() {
        const pages = this.state.pagination.totalPages;

        switch (pages) {
            case 0:
                return "0 strán";
                break;
            case 1:
                return "1 strana";
                break;
            case 2:
            case 3:
            case 4:
                return pages + " strany";
                break;
            default:
                return pages + " strán";
        }
    }

    renderList(records) {
        return records.map(record => {
            const car = this.props.cars.find(car => {
                if(car.key === record.carKey)
                    return true;
            });

            const profile = this.props.users.find(user => {
                return user.key === record.ownerId;
            });

            let fullName = 'nezadané';
            if(profile && profile.name && profile.lastName) {
                const {name, lastName} = profile;
                fullName = `${name} ${lastName}`;
            }

            return (
                <tr key={record.key}>
                    <td>
                        {moment(record.dateAdd).locale('sk').format('LLL')}
                    </td>
                    <td>
                        {fullName}
                    </td>
                    <td>{car.name}</td>
                    <td>{record.sum}</td>
                    <td>
                        <img
                            src={record.billPhotoURL}
                            alt="bill"
                            className="img-responsiv img-thumbnail"
                            style={{width: '100%', maxHeight: '170px', maxWidth: '170px', objectFit: "cover"}}
                        />
                    </td>
                    <td>{record.type}</td>
                    <td>{record.km}</td>
                    <td>
                        <div className="btn-group-vertical">
                            <button
                                type="button"
                                className="btn btn-default btn-primary"
                                onClick={() => {
                                    this.setState({
                                        showEditFuelRecord: true,
                                        editRecord: record,
                                    });
                                }}
                            >
                                Upraviť
                            </button>
                            <button
                                type="button"
                                className="btn btn-default btn-danger"
                                onClick={() => {
                                    this.props.deleteFuelRecord(record);
                                    if(this.state.editRecord)
                                        if(this.state.editRecord.key === record.key) {}
                                            this.setState({
                                                showEditFuelRecord: false,
                                                editRecord: null,
                                            });
                                }}
                            >
                                Zmazať
                            </button>
                        </div>
                    </td>
                </tr>
            );
        })
    }

    render() {
        if(!this.state.loaded)
            return <div className="alert alert-info">Načítam...</div>;

        let options = [];
        for (let i = 1; i <= this.state.pagination.totalPages; i++) {
            options.push({
                value: i,
                label: i,
            });
        }

        const usersOptions = this.props.users.map(({name, lastName}) => {
            const fullName = `${name} ${lastName}`;

            return {
                value: fullName,
                label: fullName,
            };
        });

        usersOptions.push({
            value: '',
            label: 'Všetci používatelia',
        });

        const carsOptions = this.props.cars.map(({name}) => {
            return {
                value: name,
                label: name,
            };
        });

        carsOptions.push({
           value: '',
            label: 'Všetky autá',
        });

        return (
            <div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title">Fuel Tracking</h3></div>
                    <div className="panel-body">
                        <div className="table-responsive adminFuelTracker-table-responsive">
                            <table className="table table-drop">
                                <thead>
                                <tr>
                                    <td>Vybratá strana:</td>
                                    <td>
                                        <Select clearable={false}
                                                name="form-field-name"
                                                value={this.state.pagination.page}
                                                placeholder="Vyber.."
                                                noResultsText="Žiadne záznamy.."
                                                options={options}
                                                onChange={(selectedOption) => {
                                                    this.changePage(selectedOption.value);
                                                }}
                                        />
                                    </td>
                                    <td>Celkový počet strán: </td>
                                    <td>{this.renderPagesCount()}</td>
                                </tr>
                                <tr>
                                    <td>Na stranu: </td>
                                    <td>
                                        <Select
                                            clearable={false}
                                            name="form-field-name"
                                            value={this.state.pagination.perPage}
                                            options={[
                                                {
                                                    value: 10,
                                                    label: 10,
                                                },
                                                {
                                                    value: 20,
                                                    label: 20,
                                                },
                                                {
                                                    value: 50,
                                                    label: 50,
                                                },
                                                {
                                                    value: 100,
                                                    label: 100,
                                                }
                                            ]}
                                            onChange={(perPage) => {
                                                let pagination = this.state.pagination;
                                                pagination.perPage = perPage.value;

                                                pagination.totalPages = Math.ceil(this.props.fuelRecords.length / perPage.value);

                                                if(pagination.page > pagination.totalPages)
                                                    pagination.page = pagination.totalPages;

                                                this.setState({pagination});

                                                this.changePage(pagination.page);
                                            }}
                                        />
                                    </td>
                                    <td>Celkový počet záznamov: </td>
                                    <td>{this.props.fuelRecords.length}</td>
                                </tr>
                                <tr>
                                    <th>Datum </th>
                                    <th>Kto </th>
                                    <th>Auto </th>
                                    <th>Suma </th>
                                    <th>Bloček </th>
                                    <th>Typ </th>
                                    <th>KM </th>
                                    <th>Akcie </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td colSpan={8}>
                                        <div className="col-xs-4 col-xs-offset-2">
                                            <Select
                                                clearable={false}
                                                name="form-field-name"
                                                value={this.state.filter.name}
                                                placeholder="kto"
                                                noResultsText="Žiadný uživatelia.."
                                                options={usersOptions}
                                                onInputChange={e => {
                                                    let filter = this.state.filter;
                                                    filter.name = e ? e :'';

                                                    this.setState({
                                                        filter
                                                    });

                                                    this.changePage(this.state.pagination.page);
                                                }}
                                                onChange={e => {
                                                    let filter = this.state.filter;
                                                    filter.name = e.value ? e.value :'';

                                                    this.setState({
                                                        filter
                                                    });

                                                    this.changePage(this.state.pagination.page);
                                                }}
                                            />
                                        </div>
                                        <div className="col-xs-4">
                                            <Select
                                                clearable={false}
                                                name="form-field-name"
                                                value={this.state.filter.car}
                                                placeholder="auto"
                                                noResultsText="Žiadne autá.."
                                                options={carsOptions}
                                                onInputChange={e => {
                                                    let filter = this.state.filter;
                                                    filter.car = e ? e : '';

                                                    this.setState({
                                                        filter
                                                    });

                                                    this.changePage(this.state.pagination.page);
                                                }}
                                                onChange={e => {
                                                    let filter = this.state.filter;
                                                    filter.car = e.value ? e.value : '';

                                                    this.setState({
                                                        filter
                                                    });

                                                    this.changePage(this.state.pagination.page);
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                {
                                    this.state.fuelRecords &&
                                    this.renderList(this.state.fuelRecords)
                                }
                                {
                                    !this.state.fuelRecords &&
                                    <tr>
                                        <td colSpan={8}>
                                            <div
                                                className="alert alert-info"
                                            >
                                                 Načítam...
                                            </div>
                                        </td>
                                    </tr>
                                }
                                {
                                    this.state.fuelRecords &&
                                    this.state.fuelRecords.length === 0 &&
                                    <tr>
                                        <td colSpan={8}>
                                            <div
                                                className="alert alert-warning"
                                            >
                                                Žiadne záznamy...
                                            </div>
                                        </td>
                                    </tr>
                                }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {
                    this.state.showEditFuelRecord &&
                    this.state.editRecord &&
                    <EditFuelRecord
                        editRecord={this.state.editRecord}
                        afterSubmit={function() {
                            this.setState({
                                showEditFuelRecord: false,
                                editRecord: null,
                            });
                        }.bind(this)}
                    />
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        deleteFuelRecord,
        getCars,
        getAllFuelRecords,
        getAllTrackerUsersWithProfile,
    }, dispatch);
}

function mapStateToProps({ fuelRecords, cars, users }) {
    return { fuelRecords, cars, users };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminFuelTracker);


// WEBPACK FOOTER //
// ./src/app/components/fuelTracker/adminFuelTracker.jsx